export interface TrackedScenarioRunMeta {
  runId: string;
  scenarioName: string;
  versionLabel: string;
  isDraft: boolean;
  startedAt: string;
}

export interface PendingScenarioRunMeta {
  scenarioName: string;
  versionLabel: string;
  isDraft: boolean;
  startedAt: string;
}

const STORAGE_KEY_PREFIX = 'eval-studio.scenario-runs';

function storageKey(workspaceId: string) {
  return `${STORAGE_KEY_PREFIX}.${workspaceId}`;
}

export function readTrackedScenarioRuns(workspaceId: string): TrackedScenarioRunMeta[] {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(storageKey(workspaceId));
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as TrackedScenarioRunMeta[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeTrackedScenarioRuns(workspaceId: string, runs: TrackedScenarioRunMeta[]) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (runs.length === 0) {
      window.localStorage.removeItem(storageKey(workspaceId));
      return;
    }
    window.localStorage.setItem(storageKey(workspaceId), JSON.stringify(runs));
  } catch {
    /* ignore quota / private mode errors */
  }
}

export function formatScenarioRunExecutingMessage(
  versionLabel: string,
  isDraft: boolean,
  scenarioName?: string
): string {
  const version = versionLabel.startsWith('v') ? versionLabel : `v${versionLabel}`;
  const kind = isDraft ? 'draft' : 'published version';
  if (scenarioName?.trim()) {
    return `Executing ${version} (${kind}) for ${scenarioName.trim()}…`;
  }
  return `Executing ${version} (${kind})…`;
}
